/* eslint-disable react-hooks/exhaustive-deps */
import ButtonWrap from '@/components/ButtonWrap';
import CheckBoxWrap from '@/components/CheckBoxWrap';
// import { QueryKey } from '@/constants/queryKey';

import { useMainCheckIn } from '@/hooks/useMainCheckIn';
import { FooterLayout } from '@/layout/Footer';
import { appRoutes } from '@/router/routes';

import { number } from '@/util/number';
import { Modal, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import './style.scss';

const Footer = React.memo(() => {
    const { mainCheckInState } = useMainCheckIn();

    const navigate = useNavigate();

    return (
        <FooterLayout>
            <div className="p-main-footer">
                <div className="p-main-footer__left">
                    <div className="button-group-action">
                        <ButtonWrap
                            text={`TẦNG`}
                            onClick={() => {
                                navigate(appRoutes.ADMIN.ROOM.FLOOR);
                            }}
                        />
                        <ButtonWrap
                            onClick={() => {
                                navigate(appRoutes.ADMIN.ROOM.CATEGORY);
                            }}
                            text={`LOẠI PHÒNG`}
                        />
                        <ButtonWrap
                            text={`PHÒNG`}
                            onClick={() => {
                                navigate(appRoutes.ADMIN.ROOM.ROOT);
                            }}
                        />

                        <ButtonWrap
                            text={`DANH MỤC`}
                            onClick={() => {
                                navigate(appRoutes.ADMIN.SERVICE.ROOT);
                            }}
                        />
                        <ButtonWrap
                            text={'DỊCH VỤ'}
                            onClick={() => {
                                navigate(appRoutes.ADMIN.SERVICE.ITEM);
                            }}
                        />
                    </div>
                </div>

                <div className="p-main-footer__right">
                    <div className="button-group-top">
                        <ButtonWrap
                            className="--volcano"
                            text={`BÁO CÁO`}
                            onClick={() => {
                                navigate(appRoutes.ADMIN.MANAGEMENT.REPORT);
                            }}
                        />
                        <ButtonWrap
                            type="primary"
                            text={`LỊCH SỬ`}
                            onClick={() => {
                                navigate(appRoutes.ADMIN.MANAGEMENT.HISTORY);
                            }}
                        />
                    </div>
                    <div className="button-group-bot">
                        <ButtonWrap
                            text={`THU CHI`}
                            onClick={() => {
                                navigate(appRoutes.ADMIN.THU_CHI.ROOT);
                            }}
                        />
                        <ButtonWrap
                            text={`ĐĂNG XUẤT`}
                            onClick={() => {
                                localStorage.removeItem('token');
                                window.location.href = '/login';
                            }}
                        />
                    </div>
                </div>
            </div>
        </FooterLayout>
    );
});

export default Footer;
